<template>
    <div class="content">
        <div id="preview"
             :style="{ left: pageX + 'px', top: pageY + 'px', 'display': showPreview, 'background-color': hoverColor.code, 'background-image':'url('+ previewUrl(hoverStyle,hoverColor.name)+')' }"/>
        <div class="container">
            <h1 class="mb-5">
                Create Campaign
            </h1>
            <div class="row">
                <div class="col">
                    <card-box>
                        <div class="d-inline-flex">
                            <div class="text-center mr-3">
                                <vue2-dropzone id="frontImage" :options="dropFrontOptions" :use-custom-slot="true"
                                               @vdropzone-removed-file="frontImage=''"
                                               @vdropzone-success="frontImageDone">
                                    <div class="dropzone-custom-content">
                                        <h3 class="dropzone-custom-title">
                                            Front Image
                                        </h3>
                                        <div class="subtitle">
                                            Drag and drop png art files anywhere in this box or click
                                            here to upload a front image
                                        </div>
                                    </div>
                                </vue2-dropzone>
                            </div>
                            <div class="text-center d-block">
                                <vue2-dropzone id="backImage" :options="dropBackOptions" :use-custom-slot="true"
                                               @vdropzone-removed-file="backImage=''"
                                               @vdropzone-success="backImageDone">
                                    <div class="dropzone-custom-content">
                                        <h3 class="dropzone-custom-title">
                                            Back Image
                                        </h3>
                                        <div class="subtitle">
                                            Drag and drop png art files anywhere in this box or click
                                            here to upload a back image
                                        </div>
                                    </div>
                                </vue2-dropzone>
                            </div>
                        </div>
                    </card-box>

                    <card-box class="mt-3">
                        <h5>Default available colors</h5>
                        <template v-for="color in design.colors">
                            <label v-if="color.selected !=true" :key="color.id"
                                   class="color border p-1 m-1 rounded-circle"
                                   :style="{'background-color': color.code, 'background-image': loadBackground(color.texture)}"
                                   :title="color.name" @click="selectColor(color)"/>
                        </template>
                        <h5>Selected colors</h5>
                        <small>Products will be created with these colors, if available. To remove a color, deselect
                            it.
                        </small>
                        <div>
                            <label v-for="color in selectedColor" :key="color.id"
                                   class="color border p-1 m-1 rounded-circle"
                                   :style="{'background-color': color.code, 'background-image': loadBackground(color.texture)}"
                                   :title="color.name" @click="removeColor(color)"/>
                        </div>

                        <table class="table mt-3 w-100 d-block d-md-table table-hover table-responsive">
                            <tr>
                                <th class="m-0 pl-0">
                                    #
                                </th>
                                <th class="m-0 pl-0 pr-0" colspan="2">
                                    <small>Styles</small>
                                </th>
                                <th width="80">
                                    <small>Base cost</small>
                                </th>
                                <th width="90">
                                    <small>Retail Price</small>
                                </th>
                                <th width="50">
                                    <small>Profit</small>
                                </th>
                            </tr>

                            <template v-for="style in design.styles">
                                <tr :key="style.id">
                                    <td class="m-0  pl-0">
                                        <!--<input v-model="style.selected" value="true" type="checkbox"
                                                                   :disabled="!style.defaultColor"
                                                                   @click="selectStyle(style)"
                                                                   :class="{'disable':!style.defaultColor}"/>-->


                                        <div class="custom-control custom-checkbox">
                                            <input :id="style.id" v-model="style.selected" type="checkbox"
                                                   :disabled="!style.defaultColor" class="custom-control-input"
                                                   :class="{'disable':!style.defaultColor}" name="select"
                                                   @click="selectStyle(style)">
                                            <label class="custom-control-label" :for="style.id"/>
                                        </div>
                                    </td>
                                    <td class="m-0 pl-0 pr-0 text-center">
                                        <img title="set default" :src="loadIcon(style.icon)"
                                             class="thumb-md pointer style-icon" @click="setDefault(style)">
                                        <div v-if="style.allow_back == 1" class="badge badge-light pointer front-back"
                                             @click="setFront(style)">
                                            <span v-if="style.front == false">back</span><span
                                                v-if="style.front != false">front</span>
                                        </div>
                                    </td>
                                    <td>
                                        <span title="set default" class="mr-2">{{ style.name }}</span> <span
                                            v-if="style.isDefault == true"
                                            class="badge badge-sm badge-success">default</span>
                                        <br>
                                        <template v-for="color in style.colors">
                                            <label v-if="color.selected" :key="color.id"
                                                   class="color border rounded-circle mb-1 mr-1 sm"
                                                   :style="{'background-color': color.code, 'background-image': loadBackground(color.texture)}"
                                                   :title="color.name" @mouseenter="openPreview(color,style,$event)"
                                                   @mouseleave="closePreview()" @click="setColor(color,style)"><i
                                                    v-if="style.defaultColor == color.name"
                                                    :class="{'selected': style.defaultColor == color.name}"
                                                    class="fi-check"/></label>
                                        </template>
                                    </td>
                                    <td>${{ style.base_cost }}</td>
                                    <td>
                                        <input-edit v-model="style.price" :value="parseFloat(style.base_cost) + 15"
                                                    :type="'number'" @change="changeRetailPrice(style,$event)"/>
                                    </td>
                                    <td>${{ style.profit || 15 }}</td>
                                </tr>
                            </template>
                        </table>
                    </card-box>
                </div>
                <div class="col">
                    <card-box>
                        <card-title>Design details</card-title>
                        <div class="form-group mt-3">
                            <label>Title</label>
                            <input-edit v-model="name"/>
                        </div>
                        <div class="form-group mt-3">
                            <label>Keywords</label>
                            <vue-tags-input v-model="tag" :tags="tags" @tags-changed="newTags => tags = newTags"/>
                            <small id="emailHelp" class="form-text text-muted">Separate each keyword with a comma.
                                else.
                            </small>
                        </div>
                        <div class="form-group mt-3">

                            <label>Description</label>


                            <editor :init="customToolbar"
                            api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                            v-model="description"></editor>


                        </div>
                    </card-box>


                    <card-box class="mt-3">
                        <card-title>Options</card-title>
                        <div class="form-group mt-3">
                            <toggle-button
                                    v-model="isolate"
                                    :height="24"
                                    :margin="1"
                                    :sync="true"
                            />
                            <strong> Isolate Design </strong> Only accessible through direct URL linking.
                        </div>
                        <div class="form-group mt-3">
                            <toggle-button
                                    v-model="noindex"
                                    :height="24"
                                    :margin="1"
                                    :sync="true"
                            />
                            Do not index Won't be indexed by search engines.
                        </div>
                        <hr>
                        <card-title>Time</card-title>

                        <div class="form-group mt-3">
                            <toggle-button
                                    v-model="countdown"
                                    :height="24"
                                    :margin="1"
                                    :sync="true"
                            />
                            Enable Limited Time*
                        </div>
                    </card-box>

                    <card-box class="mt-3">
                        <card-title>
                            Override default pixels
                        </card-title>
                        <div class="form-group mt-3">
                            <label>Facebook pixel</label>
                            <input-edit v-model="facebook_pixel"/>
                        </div>
                    </card-box>

                    <card-box>
                        <button
                                class="btn btn-block btn-success"
                                @click="process"
                        >
                            Process
                        </button>
                    </card-box>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue';

    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    /*import {VueEditor} from "vue2-editor"*/
    import CardBox from "@/components/CardBox"
    import CardTitle from "@/components/CardTitle"
    import InputEdit from "@/components/InputEdit"
    import vue2Dropzone from 'vue2-dropzone'
    import VueTagsInput from '@johmun/vue-tags-input'


    export default {
        name: "CreateCampaign",
        components: {
            InputEdit,
            CardTitle,
            CardBox,
            Editor,
            vue2Dropzone,
            VueTagsInput
        },
        data() {
            return {
                customToolbar: { height: 300,
                    menubar: false,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor textcolor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic forecolor  backcolor image  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat code '},
                name: '',
                facebook_pixel: '',
                isolate: false,
                noindex: false,
                countdown: false,
                tag: '',
                tags: [],
                description: "",
                design: [],
                selectedColor: [],
                dropFrontOptions: {
                    url: this.$config.api + 'design/upload',
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    headers: {
                        'Authorization': this.$http.defaults.headers.common['Authorization']
                    }
                },
                dropBackOptions: {
                    url: this.$config.api + 'design/upload',
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    headers: {
                        'Authorization': this.$http.defaults.headers.common['Authorization']
                    }
                },
                frontImage: '',
                backImage: '',
                pageX: 0,
                pageY: 0,
                showPreview: 'none',
                hoverStyle: {},
                hoverColor: {},
                submitStatus: false,
            }
        },


        watch: {

            'selectedColor': function (select) {
                let vm = this
                for (let i = 0; i < vm.design.styles.length; i++) {
                    for (let x = 0; x < vm.design.styles[i].colors.length; x++) {
                        //  let check = this.$_.findKey(vm.design.styles[i].colors[x], {vm.design.styles[i].colors[x].name })
                        vm.design.styles[i].colors[x].selected = false
                        for (let z = 0; z < select.length; z++) {
                            if (vm.design.styles[i].colors[x].name == select[z].name) {
                                vm.design.styles[i].colors[x].selected = true
                            }
                        }
                    }
                    //  console.log(vm.design.styles[i].defaultColor)
                    if (vm.design.styles[i].defaultColor == undefined || vm.design.styles[i].defaultColor == '') {
                        if (vm.design.styles[i].colors.length > 0) {
                            //  vm.design.styles[i].defaultColor = vm.design.styles[i].colors[0].name

                            for (let x = 0; x < vm.design.styles[i].colors.length; x++) {
                                if (vm.design.styles[i].colors[x].selected) {
                                    this.$set(this.design.styles[i], 'defaultColor', vm.design.styles[i].colors[x].name)
                                    break
                                }
                            }

                        }
                    }
                }


            }
        },

        mounted: function () {
            this.loadDesign()
        },
        methods: {
            changeHtmlMode: function () {
                this.htmlMode = this.htmlMode == true ? false : true
            },
            selectStyle: function (style) {
                let selected = false
                for (let i = 0; i < this.design.styles.length; i++) {
                    if (!this.design.styles[i].defaultColor) {
                        this.design.styles[i].isDefault = false
                    }
                    if (this.design.styles[i].isDefault != false) {
                        selected = true
                    }
                    if (selected == false) {
                        style.isDefault = true
                    }
                }
            },
            openPreview: function (color, style, e) {
                if (this.showPreview != 'none') return false
                this.showPreview = 'block'
                //    console.log('hove...')
                this.hoverStyle = style
                this.hoverColor = color
                this.pageX = e.pageX + 25
                this.pageY = e.pageY

            },
            closePreview: function () {
                this.showPreview = 'none'
            },
            frontImageDone: function (file, response) {
                if (response.status) {
                    this.frontImage = response.url
                } else {
                    this.$swal(response.message);
                }
            },
            backImageDone: function (file, response) {
                if (response.status) {
                    this.backImage = response.url
                } else {
                    this.$swal(response.message);
                }
            },
            changeRetailPrice: function (style, price) {
                console.log(price)
                let index = this.design.styles.indexOf(style)
                this.$set(this.design.styles[index], 'retail_price', parseFloat(price))
                this.$set(this.design.styles[index], 'profit', parseFloat(price) - style.base_cost)
            },

            loadIcon: function (icon) {
                if (icon == '') return ''
                icon = icon.replace('imgs/', '')
                return require('../assets/images/' + icon)
            },
            loadBackground: function (bg) {
                if (bg == '') return ''
                let img = bg.replace('imgs/', '')
                return 'url(' + require('../assets/images/' + img) + ')'

            },
            loadDesign: function () {
                let vm = this
                this.$http.get(this.$config.api + 'design').then(function (res) {
                    vm.design = res.data

                    for (let i = 0; i < vm.design.styles.length; i++) {
                        vm.design.styles[i].price = parseFloat(vm.design.styles[i].base_cost) + 15;
                    }

                    vm.design.styles[0].isDefault = true
                });
            },
            selectColor: function (color) {
                let check = this.$_.findKey(this.selectedColor, {id: color.id})
                if (!check) {
                    this.selectedColor.push(color)
                    color.selected = true;
                }
            },
            setFront: function (style) {
                let val = (style.front == false) ? true : false
                let index = this.design.styles.indexOf(style)
                this.$set(this.design.styles[index], 'front', val)

            },
            setDefault: function (style) {
                if (!style.defaultColor) {
                    this.$swal('Color is not available')
                    return false;
                }
                //  item.defaultColor = color.name;
                for (let i = 0; i < this.design.styles.length; i++) {
                    this.$set(this.design.styles[i], 'isDefault', false)
                }
                let index = this.design.styles.indexOf(style)
                this.$set(this.design.styles[index], 'isDefault', true)

            },
            setColor: function (color, item) {
                //  item.defaultColor = color.name;
                let index = this.design.styles.indexOf(item)
                this.$set(this.design.styles[index], 'defaultColor', color.name)

            },
            removeColor: function (color) {
                // this.selectedColor.splice(this.selectedColor.indexOf(color), 1);
                this.$delete(this.selectedColor, this.selectedColor.indexOf(color))
                color.selected = false;
                for (let i = 0; i < this.design.styles.length; i++) {
                    if (this.design.styles[i].defaultColor == color.name) {
                        this.design.styles[i].defaultColor = ''
                    }
                }

            },
            process: function () {

                if (this.submitStatus) return false;

                let vm = this


                //console.log(this.design.styles)

                let upload = {}


                if (this.frontImage == '' && this.backImage == '') {
                    this.$swal('Please upload design!')
                    return false
                }

                let checkSelectedStyle = this.$_.find(this.design.styles, function (obj) {
                    return obj.selected === true
                })

                if (!checkSelectedStyle) {
                    this.$swal('Please select style')
                    return false
                }
                // console.log(this.name.length)
                if (this.name.length == 0) {
                    this.$swal('Please enter title')
                    return false
                }
                upload.tags = []
                for (let i = 0; i < this.tags.length; i++) {
                    upload.tags.push(this.tags[i].text)
                }

                upload.name = this.name
                upload.description = this.description
                upload.isolate = this.isolate
                upload.noindex = this.noindex
                upload.countdown = this.countdown
                upload.facebook_pixel = this.facebook_pixel
                upload.frontImage = this.frontImage
                upload.backImage = this.backImage
                upload.styles = this.design.styles

                this.submitStatus = true;
                this.$http.post(this.$config.api + 'campaign/create', upload).then(function (res) {
                    //    console.log(res.data)
                    vm.submitStatus = false
                    vm.$router.push({name: 'campaign', 'query': {public: 'false'}})
                    return false
                })
                this.$swal('Create successfully!')


            },

            previewUrl: function (style, color = 'black', size = 510) {
                let sideName = 'front'
                let image = this.frontImage
                //   console.log(style.front)
                if (style == undefined) return ''
                if (style.front == false) {
                    sideName = 'back'
                    image = this.backImage
                }

                if (image == '') return ''

                color = color.replace(' ', '_');

                let filename = image.substring(image.lastIndexOf('/') + 1)

                let url = this.$config.images + 'thumb/' + size + 'x' + size + '/' + style.id + '.' + sideName + '/' + color + '.0/2018/preview/' + filename

                return url
            }


        }

    }
</script>

<style scoped lang="scss">
    #preview {
        background-size: contain;
        background-position: center;
        z-index: 1000;
        position: absolute;
        display: none;
        width: 250px;
        height: 250px;
        background-repeat: no-repeat;
    }

    .pointer {
        cursor: pointer;
    }

    .style-icon {
        &:hover {
            border: 2px solid #32c861;
        }
    }

    .front-back {
        &:hover {
            color: red;
        }
    }

    label.color {
        width: 2rem;
        height: 2rem;
        cursor: pointer;
        overflow: hidden;
        text-align: center;

        &.sm {
            width: 1.7em;
            height: 1.7em;
        }

        .selected {
            color: #fff;
            mix-blend-mode: difference;
        }
    }

    .dropzone {
        overflow: hidden;
        padding: 0;

        .dz-details {
            overflow: hidden;
        }
    }

</style>
